<template>
  <el-dialog title="" :visible.sync="visible" :width="width" center :top="top">
    <div class="message_box" :style="{ height: height }">
      <div class="message_box_title">{{ textTitle }}</div>
      <div class="message_box_main">
        <slot name="content">
          <slot></slot>
        </slot>
      </div>
      <div class="message_box_btn" :style="{ '--flexDir': flexDir }" v-if="showBtn">
        <el-button
          v-if="moreBtnText"
          class="message_box_btn_text more-btn"
          @click="confirm(moreBtnText)">
          {{ moreBtnText }}
        </el-button>
        <el-button class="message_box_btn_text" @click="ok(yesBtnText)">{{ yesBtnText }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ShowMessageBox',
  props: {
    textTitle: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '504px'
    },
    height: {
      type: String,
      default: '200px'
    },
    top: {
      type: String,
      default: '15vh'
    },
    textContent: {
      type: String,
      default: ''
    },
    yesBtnText: {
      type: String,
      default: ''
    },
    // 另一个按钮 通常是一个
    moreBtnText: {
      type: String,
      default: ''
    },
    // 按钮排列方向
    flexDir: {
      type: String,
      default: 'row'
    },
    // 是否显示按钮
    showBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    init() {
      this.visible = true;
    },
    ok(content) {
      this.visible = false;
      this.$emit('dialogConfirm', content);
    },
    confirm(content) {
      this.visible = false;
      this.$emit('dialogMoreConfirm', content);
    }
  }
};
</script>

<style lang="less">
.message_box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &_title {
    width: auto;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
  }
  &_main {
    width: auto;
    margin: 0 auto;
    text-align: center;
    color: rgba(0, 0, 0, 0.45);
    font-size: 16px;
    line-height: 24px;
  }
  &_btn {
    margin: 20px auto;
    text-align: center;
    flex-direction: var(--flexDir);
    display: flex;
    align-items: flex-end;
    gap: 8px;
    &_text {
      min-width: 164px;
      height: 50px;
      color: #fff;
      background-color: #21a56c;
      border-radius: 8px;
      span {
        font-family: OPPOSans;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      &:hover,
      &:focus {
        color: #fffefe;
        background-color: #289e6b;
      }
    }
    .more-btn {
      border-radius: 8px;
      border: 1px solid var(---, #21a56c);
      background: none;
      span {
        color: var(---, #21a56c);
        font-family: OPPOSans;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
}
@media (max-width: 767px) {
  .message_box {
    &_title {
      color: rgba(0, 0, 0, 0.85);
      font-family: OPPOSans;
      font-size: 3.7333vw;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      font-weight: 600;
    }
    &_main {
      width: auto;
      margin: 0 auto;
      text-align: center;
      color: rgba(0, 0, 0, 0.45);
      font-size: 16px;
      line-height: 24px;
    }
    &_btn {
      margin: 20px auto;
      text-align: center;
      flex-direction: var(--flexDir);
      display: flex;
      align-items: flex-end;
      gap: 8px;
      &_text {
        min-width: 37.3333vw;
        height: 11.7333vw;
        padding: 0.85vw 3.4vw;
        justify-content: center;
        align-items: center;
        color: #fff;
        border-radius: 48.6439vw;
        background: #07a34f;
        span {
          color: #fff;
          font-family: OPPOSans;
          font-size: 3.4667vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        &:hover,
        &:focus {
          color: #fffefe;
          background-color: #289e6b;
        }
      }
      .more-btn {
        border-radius: 8px;
        border: 1px solid var(---, #21a56c);
        background: none;
        span {
          color: var(---, #21a56c);
          font-family: OPPOSans;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
  }
}
</style>
